<template>
<div class="info">
	<div class="title">保障信息</div>
	<Form :label-width="120" ref="form" class="mt15">
		<template>
			<FormItem label="保障类型：" class="w600">{{info.policyTimeType=='1'?'年单':'月单'}}</FormItem>
			<FormItem label="保障起期：" class="w600">{{info.beginDate}}</FormItem>
			<FormItem label="保障止期：" class="w600">{{info.endDate}}</FormItem>
		</template>
	</Form>
	<div class="recognize-table mt10 pb20">
		<el-table class="mt10" ref="table" :data="info.detailList" border style="width: 100%">
			<el-table-column prop="name" label="设备名称" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="code" label="车架号/发动机号" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="productFactory" label="生产厂家" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="useAddress" label="使用区域" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="feeBearGroup" label="费用承担主体" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="feeBearCode" label="费用承担主体编码" width="180"></el-table-column>
			<el-table-column prop="costBearCode" label="成本承担主体编码" width="180"></el-table-column>
			<el-table-column prop="price" label="保费(元)" width="110">
				<template slot-scope="{ row }">
					{{row.price||'-'}}
				</template>
			</el-table-column>
		</el-table>
	</div>
</div>
</template>
<script>
export default {
	props:{
		info:Object
	},
	data () {
		return {
		}
	},
	computed:{
	},
	methods: {
	}
}
</script>
<style scoped lang="less">
	.info{
		margin-top:10px;
	}
	.title-a{
		font-size: 14px;
		margin-left: 15px;
	}
	.pb20{
		padding-bottom: 20px;
	}
    .correctUrlItem{
        margin-right: 20px;
        text-align: center;
		a{
			font-size: 12px;
			// display: block;
            margin-right: 5px;
		}
    }
	.subtitle {
		color: #FF9900;
		font-size: 16px;
		margin-left: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/forklift/recognizeInfo.vue